import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./FooterAndFloating";

export default function NotFoundPage() {
  useEffect(() => {
    const previous = document.title;
    document.title = "Page not found | The Business Playwright";
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    return () => { document.title = previous; meta.remove(); };
  }, []);

  return (
    <div className="bp-site" data-testid="not-found-page">
      <Header />
      <main id="main" className="bp-hero">
        <div className="bp-wrap bp-hero-inner">
          <span className="bp-hero-rule" aria-hidden="true" />
          <h1 className="bp-hero-title" style={{ fontSize: "clamp(2rem, 4vw, 4.2rem)" }} data-testid="not-found-title">Page not found</h1>
          <p className="bp-hero-line3">
            <Link to="/" className="ab-mail" data-testid="not-found-home-link">Return to the homepage</Link>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
